import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  align-items: flex-end;
  justify-content: space-between;

  .messageAlert {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 5px;

    span {
      font-size: 1.2rem;
    }
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 70%;
  gap: 8px;
`;
